module.exports = __webpack_public_path__ + "static/img/4.7dcb74b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/eng/4.png
// module id = Q3+1
// module chunks = 0